import { PassOrFail } from "@gtpl/shared-models/common-models"

export class JobReportingInfoReq {
    operation?:string
    lotNumber?:string
    product?:string
    prevOperation?:string
  fromDate?: any
  toDate?: any
  status?:PassOrFail

    constructor(operation?:string,lotNumber?:string,product?:string,prevOperation?:string,fromDate?:any,toDate?:any,status?:PassOrFail) {
        this.operation=operation
        this.lotNumber = lotNumber
        this.prevOperation = prevOperation
        this.product = product
        this.fromDate = fromDate
        this.toDate = toDate
        this.status = status
    }
}
